import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuBar from './common/MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import { loadRxDetails, validateOrder, savePrescription, unlockRXDetails,
   fetchAvailityMemberCoverage, loadAccumulator, getAttachmentPath, loadMemberConcern
  ,getWinCardUrl, getOpenOrdersFile } from '../Services/loadOrder';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../assets/css/home.css';
import NeedsTrackingModal from './common/NeedsTrackingModal';
import { Toaster, toast } from 'react-hot-toast';

const SubmittedClaimsOpenOrder = () => {
  const { state = {} } = useLocation();
  const navigate = useNavigate();

  const [taskDetail, setTaskDetail] = useState(null);
  const [gridRows, setGridRows] = useState([]);
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [TotalMemberPays, setTotalMemberPays] = useState('0.00');
  const [totalCopay, setTotalCopay] = useState('0.00');
  const [totalMenopurCostShare, setTotalMenopurCostShare] = useState(0);
  const [totalWinPays, setTotalWinPays] = useState('0.00');
  const [shippingCarrier, setShippingCarrier] = useState('');
  const [trackingNumber, setTrackingNumber] = useState('');
  const [Prescriptions, setPrescriptions] = useState([]);
  const [shipping, setShipping] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [pendingRollbackInfo, setPendingRollbackInfo] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [taskDetail2, setTaskDetail2] = useState(null);
  const [sourceData, setSourceData] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [notesBoxActive, setNotesBoxActive] = useState(false);


  const { taskId, contract, pharmacyId, userId } = state;
  const [chewyRows, setChewyRows] = useState([]);
    const [chewyFertilityRows, setChewyFertilityRows] = useState([]);
      const [notes, setNotes] = useState(taskDetail?.Notes || '');
      const [attachmentUrls, setAttachmentUrls] = useState([]);
      const [mainGridRows, setMainGridRows] = useState([]);
        const [menopurGridRows, setMenopurGridRows] = useState([]);
        const [memberConcernFlag, setMemberConcernFlag] = useState(false);
        const [memberConsent, setMemberConsent] = useState(false);
        const [winCardAmount, setWinCardAmount] = useState('0.00');
        const [contractType, setContractType] = useState('');
        const [showMemberWinCard, setShowMemberWinCard] = useState(false);
        const [totalCostShare, setTotalCostShare] = useState('0.00');
    
  
  
    // for chewy contracts
    
    useEffect(() => {
      if (contract !== 'Chewy-Aetna-Premier' || !taskDetail) return;
    
      const fetchChewyGridsData = async () => {
        let memberId = taskDetail?.MemberID;
        let patientFirstName = taskDetail?.MemberName;
        let patientLastName = taskDetail2?.MemberName;
        let patientBirthDate = taskDetail?.DOB;
        let sourceSystem = "PBMS";
        let user = userId;
        console.log("Fetching Chewy grids data with:", {
          memberId, 
          patientFirstName,
          patientLastName,
          patientBirthDate,
          contract,
          sourceSystem,
          user
        });
    
        if (
          memberId?.toLowerCase().includes("test") &&
          patientFirstName?.toLowerCase().includes("test") &&
          patientLastName?.toLowerCase().includes("test")
        ) {
          memberId = "234651_10";
          patientFirstName = "Lea";
          patientLastName = "Spencer";
          patientBirthDate = "10/08/1987";
          sourceSystem = "PBMS Test";
          user = "SADV";
        }
    
        const availityData = await fetchAvailityMemberCoverage({
          memberId,
          patientFirstName,
          patientLastName,
          patientBirthDate,
          contract,
          sourceSystem,
          user
        });
    
        // ---- Parse availityData to extract accumulator values ----
        let deductibleTotal = "0.00";
        let deductibleRemaining = "0.00";
        let coinsurancePercent = "0";
        let copayAmount = "0.00";
    
        try {
          const plans = availityData?.plans;
          if (plans && Array.isArray(plans)) {
            // Find the first plan with benefits
            const benefits = plans[0]?.benefits;
            if (benefits && Array.isArray(benefits)) {
              // Deductibles
              const amounts = benefits[0]?.amounts;
              const deductibles = amounts?.deductibles?.inNetwork || [];
              // Prefer "Individual", else "Family"
              const indDed = deductibles.find(x => x?.level === "Individual");
              const famDed = deductibles.find(x => x?.level === "Family");
              if (indDed) {
                deductibleTotal = indDed?.total?.toString() ?? "0.00";
                deductibleRemaining = indDed?.remaining?.toString() ?? "0.00";
              } else if (famDed) {
                deductibleTotal = famDed?.total?.toString() ?? "0.00";
                deductibleRemaining = famDed?.remaining?.toString() ?? "0.00";
              }
    
              // Coinsurance and Copay (from Infertility benefit, usually index 1)
              let planName = availityData?.planName || ""; // You may need to get this from somewhere else
              let coinsurance = 0;
              let copay = 0;
              if (benefits.length > 1) {
                // Try to get from Infertility benefit
                const infertilityAmounts = benefits[1]?.amounts;
                // Coinsurance
                const coins = infertilityAmounts?.coInsurance?.inNetwork?.[0]?.amount;
                coinsurance = coins ? parseFloat(coins) * 100 : 0;
                // Copay
                const copayVal = infertilityAmounts?.coPayment?.inNetwork?.[0]?.amount;
                copay = copayVal ? parseFloat(copayVal) : 0;
              }
              // If not found, fallback to plan type
              if (!coinsurance && planName.includes("PPO")) {
                coinsurance = 20;
                copay = 50;
              } else if (!coinsurance) {
                coinsurance = 10;
                copay = 0;
              }
              coinsurancePercent = coinsurance.toString();
              copayAmount = copay.toFixed(2);
            }
          }
        } catch (err) {
          console.error("Error parsing availityData:", err);
          toast.error("Failed to parse member coverage data");
        }
    
        // ---- Build DataGrid rows ----
        setChewyRows([
          {
            id: 1,
            'Member Cost Share': 'Deductible Total',
            'In-Network': `$ ${deductibleTotal}`,
            'Out-of-Network': 'NA'
          },
          {
            id: 2,
            'Member Cost Share': 'Deductible Remaining',
            'In-Network': `$ ${deductibleRemaining}`,
            'Out-of-Network': 'NA'
          },
          {
            id: 3,
            'Member Cost Share': 'Coinsurance',
            'In-Network': `${coinsurancePercent} %`,
            'Out-of-Network': 'NA'
          },
          {
            id: 4,
            'Member Cost Share': 'Copay',
            'In-Network': `$ ${copayAmount}`,
            'Out-of-Network': 'NA'
          }
        ]);
      };
    
      fetchChewyGridsData();
    }, [contract, taskDetail, userId]);
    
    const chewyColumns = [
      { field: 'Member Cost Share', headerName: 'Member Cost Share', width: 200, headerClassName: 'pink-header' },
      { field: 'In-Network', headerName: 'In-Network', width: 150, headerClassName: 'pink-header' },
      { field: 'Out-of-Network', headerName: 'Out-of-Network', width: 150, headerClassName: 'pink-header' }
    ];
    
    
    const chewyColumnsFertilityGrid = [
      { field: 'Fertility Accumulator', headerName: 'Fertility Accumulator', width: 200, headerClassName: 'pink-header' },
      { field: 'In-Network', headerName: 'In-Network', width: 150, headerClassName: 'pink-header' },
      { field: 'Out-of-Network', headerName: 'Out-of-Network', width: 150, headerClassName: 'pink-header' }
    ];
    useEffect(() => {
      if (contract !== 'Chewy-Aetna-Premier' || !taskDetail) return;
    
      const fetchChewyAccumulator = async () => {
        try {
          const result = await loadAccumulator(taskDetail?.MemberID, taskDetail?.AuthNo, contract);
          console.log("Accumulator Payload:", {
            MemberID: taskDetail?.MemberID,
            AuthNo: taskDetail?.AuthNo,
            Contract: contract
          });
          console.log("Accumulator Data:", result);
    
          if (result.success && result.data) {
            setChewyFertilityRows([
              {
                id: 1,
                'Fertility Accumulator': 'Benefit Limit',
                'In-Network': `$ ${result.data.AllowedAccumulator ?? '0.00'}`,
                'Out-of-Network': 'NA'
              },
              {
                id: 2,
                'Fertility Accumulator': 'Remaining Balance',
                'In-Network': `$ ${result.data.RemainingAccumulator ?? '0.00'}`,
                'Out-of-Network': 'NA'
              }
            ]);
          } else {
            setChewyFertilityRows([]);
            toast.error(result.message || "No accumulator data found.");
          }
        } catch (error) {
          console.error("Error fetching accumulator data:", error);
          toast.error("Failed to fetch accumulator data");
          setChewyFertilityRows([]);
        }
      };
    
      fetchChewyAccumulator();
    }, [contract, taskDetail]);

  useEffect(() => {
    const fetchRx = async () => {
      try {
        const result = await loadRxDetails(taskId, contract, pharmacyId, userId);
        const data = result?.data || {};

        const task = data.TaskDetail?.[0] || {};
        const task2 = data.TaskDetail?.[1] || {};
        const shippingInfo = data.ShippingInfos?.[0] || {};
        const prescriptions = data.Prescriptions || [];
        const document = data.Documents || [];
        console.log("this is the document array", document);
        console.log("prescriptions data:------@", prescriptions);

        if (result.success) {
        
          let memberConcern;
          if (task.ContractType === 'Premier' || contract === "Moelis-Cigna-Premier Rx") {
        memberConcern = await loadMemberConcern(taskId, contract);
        console.log("Member Concern Data:", memberConcern);

        if (memberConcern.data) {
          if (memberConcern.data.Flag === 'Y') {
            setMemberConcernFlag(true);
          }
          if (memberConcern.data.MemberConsent === 'Y') {
            setShowMemberWinCard(true);
          }
          console.log("Member Concern Data for Menopur Cost Share:", memberConcern.data.MenopurCostshare);
          setTotalMenopurCostShare(parseFloat(memberConcern.data.MenopurCostshare || 0));
        }
      }
      

        const fetchUrls = async () => {
              const urls = await Promise.all(
                document.map(doc => getAttachmentPath(doc.Path))
              );
              console.log("Fetched attachment URLs:", urls);
              setAttachmentUrls(urls);}
              fetchUrls();

              const costShareValue = prescriptions[0]?.CostShare || '0.00';

       
        setSourceData(data);      
        setTaskDetail(task);
        setTaskDetail2(task2);
        setShipping(shippingInfo);
        setShippingCarrier(shippingInfo.ShippingCarrier || '');
        setTrackingNumber(shippingInfo.TrackingNo || '');
        setPrescriptions(prescriptions);
        setDocuments(document);
        setContractType(task?.ContractType || '');

        if ((memberConcern && memberConcern.data.Flag === 'Y') && (task?.ContractType === 'Premier'
          || contract === "Moelis-Cigna-Premier Rx"
        )) {
        
                  //  const rebateFlag = await loadRebateValidationFlag( contract,
                  //           task?.MemberID, pharmacyId, userId );
                  //         setRebateValidationFlag(rebateFlag?.Validation === 'Y' ? 'Y' : 'N');
                  
                          // Use details.Prescriptions for initial grid setup
                    const Prescriptions = prescriptions;
                    const contractType = task?.ContractType;
                    const pharmacyID = task?.PharmacyID || pharmacyId;
                    console.log("Prescription data for menopurcase:::::::", Prescriptions);
                  
                    console.log("Contract Type:", contractType);
                  
                    // Split prescriptions into Menopur and others
                    const menopurRows = Prescriptions.filter(p => p.DrugName?.toUpperCase().includes('MENOPUR'));
                    const otherRows = Prescriptions.filter(p => !p.DrugName?.toUpperCase().includes('MENOPUR'));
                  
                    console.log("Menopur Rows:-------$", menopurRows);
                    console.log("Other Rows:------$", otherRows);
                    const mainRows = otherRows.map((p) => ({
                      id: p.PresID ,
                      Effdt: p.MedStartDate || '',
                      NDC: p.NDC || '',
                      DrugName: p.DrugName || '',
                      GPIName: p.GPIName || '',
                      AppQty: p.AppQty ?? '',
                      Units: p.Units ?? '',
                      DispQty: p?.['Disp Qty'] ?? '',
                      CancelQty: p?.['Cancel Qty'] ?? '',
                      Reason: p.Reason || '',
                      ['Member Pays']: parseFloat(p?.['Member Pays'] || 0).toFixed(2),
                      ['Reimbursment Amount']: parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2),
                    }));
                    const menopurRowsGrid = menopurRows.map((p) => ({
                      id: p.PresID ,
                      Effdt: p.MedStartDate || '',
                      NDC: p.NDC || '',
                      DrugName: p.DrugName || '',
                      GPIName: p.GPIName || '',
                      AppQty: p.AppQty ?? '',
                      Units: p.Units ?? '',
                      DispQty: p?.['Disp Qty'] ?? '',
                      CancelQty: p?.['Cancel Qty'] ?? '',
                      Reason: p.Reason || '',
                      ['Member Pays']: parseFloat(p?.['Member Pays'] || 0).toFixed(2),
                      ['Reimbursment Amount']: parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2),
                    }));
                  
                    setMenopurGridRows(menopurRowsGrid);
                  
                    setMainGridRows(mainRows);
                  
                    // after setMenopurGridRows(...) and setMainGridRows(...)
                  setGridRows([
                    ...menopurRows.map(pres => ({ ...pres, id: pres.PresID, CancelQty: parseFloat(pres.AppQty||0)-parseFloat(pres.DispQty||0) })),
                    ...otherRows.map(pres   => ({ ...pres, id: pres.PresID, CancelQty: parseFloat(pres.AppQty||0)-parseFloat(pres.DispQty||0) })),
                  ]);
                  
                  
                  return; // keep your early return
                  
                }

        

        const rows = prescriptions.map((p, i) => {
          const baseRow = {
            id: p.PresID || i + 1,
            Effdt: p.MedStartDate || '',
            NDC: p.NDC || '',
            DrugName: p.DrugName || '',
            GPIName: p.GPIName || '',
            AppQty: p.AppQty ?? '',
            Units: p.Units ?? '',
            DispQty: p?.['Disp Qty'] ?? '',
            CancelQty: p?.['Cancel Qty'] ?? '',
            Reason: p.Reason || '',
            ['Member Pays']: parseFloat(p?.['Member Pays'] || 0).toFixed(2),


          };

          if (contract === 'HMO Illinois' || contract === 'WINFertilityRx' || 
            contract === 'WINFertility Genetics' || contract === 'WINFertility DTC') {
            baseRow.Amount = parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2);
          } else if (task?.ContractType === 'Premier' || contract === "Moelis-Cigna-Premier Rx") {
            baseRow['Reimbursment Amount'] = parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2);
          }

          return baseRow;
        });

        console.log("Grid Rows: =====>", rows);
        setGridRows(rows);
         setTotalCostShare(costShareValue);

      if (contract === 'HMO Illinois' || contract === 'WINFertilityRx'
         || contract === 'WINFertility DTC') {
        const total = rows.reduce((sum, r) => sum + (parseFloat(r.Amount) || 0), 0);
        console.log(`Total Amount ${contract}: =====>`, total);
        setTotalWinPays(total.toFixed(2));
         }
  //       const total = (contract === 'HMO Illinois' || contract === 'WINFertilityRx' ||
  //   contract === 'WINFertility Genetics' || contract === 'WINFertility DTC')
  // ? rows.reduce((sum, r) => sum + (parseFloat(r['Reimbursment Amount']) || 0), 0)
  // : 0;
  //         console.log("Total Reimbursment Amount: =====>", total);
        
  //       setTotalWinPays(total.toFixed(2));

        }
      } catch (error) {
        console.error('Error loading RX details:', error);
        navigate('/error-page');
      }
    };

   

    if (taskId && contract && pharmacyId && userId) {
      fetchRx();
    }
  }, [taskId, contract, pharmacyId, userId]);


  // calculate TotalMemberPays and TotalWinPays for Premier contracts


  useEffect(() => {
    console.log("Calculating cost share with::::::", { gridRows, mainGridRows, menopurGridRows, memberConcernFlag, contractType, contract });
    if (!gridRows || (!mainGridRows && !menopurGridRows)) return;
    if (contractType !== 'Premier' && contract !== 'Moelis-Cigna-Premier Rx' ) return;
  
    const fetchCostShare = async () => {
      console.log ("=====entered to the cost share calculation=====");
      
      let rxCost;
    let totalcostShare;
    let copay;
    let reimbAmountMain;
    let reimbAmountMenopur;
    let memberPaysMenopur;
    let memberPaysMain;
    let winCardAmount;

    // if( rebateValidationFlag === 'Y'){
    //   copay = parseFloat(rxData?.Prescriptions?.[0]?.Rx_Cost_Before_CostShareAMT);
      
    // } else if (rebateValidationFlag === 'N') {
   
    // copay = parseFloat(totalWinPaysBase);
    // }
    
    // const offerAmount = await calculateCostShareDetails(copay);

    if (memberConcernFlag === true) {
      reimbAmountMain = mainGridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
      reimbAmountMenopur = menopurGridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
      const copayMenopur = menopurGridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
      const copayMain = mainGridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
      const totalcopay = copayMenopur + copayMain;
      memberPaysMenopur = totalMenopurCostShare;
      memberPaysMain = Prescriptions[0]?.CostShare - memberPaysMenopur;
      winCardAmount = reimbAmountMenopur - memberPaysMenopur;
      copay = parseFloat(memberPaysMain + memberPaysMenopur).toFixed(2);
      rxCost = parseFloat(reimbAmountMain + reimbAmountMenopur).toFixed(2);
      totalcostShare = memberPaysMenopur + memberPaysMain;
      //(rxCost - menopurTotal - totalCostShare) + menopurCostShare
      console.log("This is the copay: =====>", copay);
      console.log("This is the reimbusrement Amount: =====>", reimbAmountMain + reimbAmountMenopur);
      console.log("This is the winCardAmount: =====>", winCardAmount);
      console.log("This is the rxCost: =====>", rxCost);
      console.log("This is the reimbAmountMenopur: =====>", reimbAmountMenopur);
      console.log("This is the totalCostShare: =====>", totalcostShare);
      console.log("This is the memberPaysMenopur: =====>", memberPaysMenopur);
      console.log("This is totalcopay: =====>", totalcopay);
      setTotalCopay(totalcopay || '0.00');
      setTotalMemberPays(totalcostShare || '0.00');
      setTotalCostShare(totalcostShare || '0.00');
      setTotalWinPays( (((Number(rxCost) - Number(reimbAmountMenopur)) - Number(totalcostShare) )+ Number(memberPaysMenopur)) || '0.00');
      setWinCardAmount(winCardAmount.toFixed(2) || '0.00');
      

    } else {
      copay = gridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
      reimbAmountMain = gridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
      setTotalCopay(copay.toFixed(2) || '0.00');
      
      console.log("This is the copay: =====>", copay);
      console.log("This is the reimbusrement Amount: =====>", reimbAmountMain);
      setTotalMemberPays(totalCostShare || '0.00');
      setTotalWinPays(parseFloat(reimbAmountMain - totalCostShare).toFixed(2) || '0.00');
    }
  
      //setTotalMemberPays(offerAmount || '0.00');
  
    };
    fetchCostShare();
  }, [taskDetail, gridRows ]);

//   useEffect(() => {
//   if (
//     (taskDetail?.ContractType?.trim() === 'Premier' || taskDetail?.Contract?.trim() === 'Premier') &&
//     Prescriptions.length > 0
//   ) {
//     const totalMemberPays = Prescriptions.reduce(
//       (sum, row) => sum + (parseFloat(row?.['Member Pays'] || 0)),
//       0
//     );
//     setTotalMemberPays(totalMemberPays.toFixed(2));
//     const winPays = parseFloat(totalAmount) - totalMemberPays;
//     setTotalWinPays(winPays.toFixed(2));
//   }
// }, [taskDetail, Prescriptions, totalAmount]);

  const handleRollback = async () => {
    try {
      const result = await validateOrder({ contract, pharmacyId, taskId });
      const allowRollback = result?.ReturnValue == null;

      setModalMessage(
        allowRollback
          ? "The claim will be rolled back to Process Prescription."
          : "This claim order is under process. You cannot rollback the order."
      );

      setShouldRedirect(allowRollback);
      setPendingRollbackInfo({ contract, pharmacyId, taskId, userId });
      setModalOpen(true);
    } catch (err) {
      console.error("Rollback Error:", err);
      toast.error("An error occurred while processing rollback.");
      navigate('/error-page');
    }
  };

  const handleModalConfirm = async () => {
    setModalOpen(false);
    if (!shouldRedirect || !pendingRollbackInfo) return;

    const { contract, taskId, pharmacyId, userId } = pendingRollbackInfo;
    const memberID = taskDetail?.MemberID;
    const authNo = taskDetail?.AuthNo;
    const priorityID = taskDetail?.PriorityID;
    const schStartDate = taskDetail?.SchStartDate;
    const schEndDate = taskDetail?.SchEndDate;

    if (!contract || !taskId || !memberID) {
      toast.error("Missing required prescription data. Cannot proceed.");
      navigate('/error-page');
      return;
    }

    try {
      setIsSubmitting(true);

      for (const row of gridRows) {
        await savePrescription({
          Loop: 1,
          Flag: "Rollback",
          Contract: contract,
          PharmacyID: pharmacyId,
          TaskID: taskId,
          LineID: row.id?.toString() || "",
          NDC: row.NDC,
          DispQty: row?.DispQty || row?.['Disp Qty'],
          Copay: 0,
          Amount: parseFloat(row.Amount || row['Reimbursment Amount'] || 0),
          TaskType: "SC",
          UserID: userId,
          ScheduleStartDate: schStartDate,
          ScheduleEndDate: schEndDate,
          Message: "",
          MemberID: memberID,
          AuthNo: authNo,
          TotCoPay: 0,
          TotAmount: parseFloat(totalAmount),
          PriorityID: priorityID,
          ShippingCarrier: shippingCarrier,
          TrackingNo: trackingNumber,
          Notes: taskDetail?.notes || '',
          Reason: row.Reason || '',
          WithWinMarginWithoutRebate: 0,
          WintoPharmAmt: parseFloat(row.Amount || row['Reimbursment Amount'] || 0)
        });
      }

      await savePrescription({
        Loop: 0,
        Flag: "Rollback",
        Contract: contract,
        PharmacyID: pharmacyId,
        TaskID: taskId,
        LineID: "",
        NDC: "",
        DispQty: 0,
        Copay: 0,
        Amount: parseFloat(totalAmount),
        TaskType: "SC",
        UserID: userId,
        ScheduleStartDate: schStartDate,
        ScheduleEndDate: schEndDate,
        Message: "",
        MemberID: memberID,
        AuthNo: authNo,
        TotCoPay: 0,
        TotAmount: parseFloat(totalAmount),
        PriorityID: priorityID,
        ShippingCarrier: shippingCarrier,
        TrackingNo: trackingNumber,
        Notes: taskDetail?.notes || '',
        Reason: "",
        WithWinMarginWithoutRebate: 0,
        WintoPharmAmt: 0
      });

      await unlockRXDetails(contract, userId, taskId, pharmacyId);
      toast.success("Prescription submitted successfully!");

      navigate('/submitted-claims', {
        state: { taskId, contract, pharmacyId, userId, fromRollback: true }
      });
    } catch (err) {
      console.error("Rollback unlock failed:", err);
      toast.error("Unlock failed during rollback.");
      navigate('/error-page');
    } finally {
      setIsSubmitting(false);
    }
  };


  // document mapping

  const document = documents || [];

    const documentArray = document.map((doc, index) => ({

      id: index,
      documentList: doc.Path,
      bytes: doc.PDFDocument,
    })
  
  )

  const documentArraylength = documentArray.length;

  console.log("Document Array:", {documentArray, documentArraylength});

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data URL prefix
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

   const handleFileDisplay = async (file, bytes) => {
  if (!file) return;

  let fileName = typeof file === 'string' ? file : file.name;
  const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
  const docType = 'Prescription';
  const memberID = Array.isArray(taskDetail) ? taskDetail[0]?.MemberID : taskDetail?.MemberID;

  const base64 = bytes;

  
    try {
      const response = await getOpenOrdersFile(memberID, fileName, contract, docType, base64); // Pass null or omit base64
      if (response) {
        window.open(response, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      console.error("Error fetching file:", error);
      toast.error('Failed to fetch file');
    }
    return ;
  
};

const confirmBack = async () => {
  try {
    

    toast.success("Order details cleared successfully.");

    await unlockRXDetails(contract, userId, taskId, pharmacyId);

    toast.success("Task unlocked successfully.");

    navigate('/submitted-claims', {
      state: {
        taskId,
        contract,
        pharmacyId,
        userId,
       
      }
    });
  } catch (err) {
    console.error("Error in handleBack:", err);
    toast.error("An error occurred while navigating back.");
    navigate('/error-page');
  }
};



  const columns = [
    { field: 'Effdt', headerName: 'Med Start Date',flex:1, headerClassName: 'pink-header', sortable: false, },
    { field: 'NDC', headerName: 'NDC', flex:1, headerClassName: 'pink-header', sortable: false,

     },
    { field: 'DrugName', headerName: 'Drug Name', flex:1, headerClassName: 'pink-header', sortable: false,
     renderCell: (params) => (
      <div
        style={{
        display: 'flex',
        alignItems: 'center',   // vertical center
        justifyContent: 'left', // horizontal center
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        textAlign: 'left',
        padding: '2px 4px', // keep small padding
        width: '100%',
        height: '100%',     // ensures full cell height for vertical centering
      }}
      >
        {params.value}
      </div>
    ),
     },
    { field: 'GPIName', headerName: 'GPI Name',flex:1, headerClassName: 'pink-header', sortable: false,
     renderCell: (params) => (
      <div
        style={{
        display: 'flex',
        alignItems: 'center',   // vertical center
        justifyContent: 'left', // horizontal center
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        textAlign: 'left',
        padding: '2px 4px', // keep small padding
        width: '100%',
        height: '100%',     // ensures full cell height for vertical centering
      }}
      >
        {params.value}
      </div>
    ),
     },
    { field: 'AppQty', headerName: 'App Qty',flex:1, headerClassName: 'pink-header', sortable: false, },
    { field: 'Units', headerName: 'Units', flex:1, headerClassName: 'pink-header', sortable: false, },
    { field: 'DispQty', headerName: 'Disp Qty', flex:1, headerClassName: 'pink-header', sortable: false, },
    { field: 'CancelQty', headerName: 'Cancel Qty', flex:1, headerClassName: 'pink-header', sortable: false, },
    { field: 'Reason', headerName: 'Reason', flex:1, headerClassName: 'pink-header', sortable: false, },
  ];

  if (contract === 'HMO Illinois' || contract === 'WINFertilityRx' || 
            contract === 'WINFertility Genetics' || contract === 'WINFertility DTC') {
    columns.push({ field: 'Amount', headerName: 'Amount', width: 180, headerClassName: 'pink-header', sortable: false, });
  } else if (taskDetail?.ContractType === 'Premier' || contract === 'Moelis-Cigna-Premier Rx') {
    columns.push({ field: 'Reimbursment Amount', headerName: 'Reimbursment Amount', width: 180, headerClassName: 'pink-header', sortable: false, });
  }

  const winCardCol = {
        field: 'WinCard',
        headerName: 'WinCard',
        width: 200,
        sortable: false,
        headerClassName: 'pink-header',
        renderCell: (params) => {
          if (!params.row.DrugName?.toUpperCase().includes('MENOPUR') || params.row.isSummary) return null;
      
          if (showMemberWinCard){
          return (
            <button
              style={{
                padding: '4px 12px',
                borderRadius: '8px',
                background: '#ec008c',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
                fontSize: '13px'
              }}
              onClick={async () => {
                const info = {
                  PresID: params.row.PresID,
                  MemberID: params.row.MemberID,
                  // ...add other required fields if needed
                };
                const winCardLink = await getWinCardUrl(info);
                if (winCardLink) {
                  window.open(winCardLink, '_blank'); // Open the URL in a new tab
                } else {
                  toast.error("Win Card link not available.");
                }
              }}
            >
              View WinCard
            </button>
          );
        } else if (!showMemberWinCard) {
          return (
            <span style={{ color: 'gray',  fontSize: '12px' }}>
              Call member to get card details
            </span>
          );
      
        }
        }
      }
      //  Menopur grid columns: start from main and then add WINCard when that scenario applies
      const showWinCard =
        (memberConcernFlag === true ) &&
        (contractType=== 'Premier' || contract === 'Moelis-Cigna-Premier Rx' );
      
      const columnsMenopur = showWinCard ? [...columns, winCardCol] : columns;

  //summary row for total amount
  const totalReimbursement = Prescriptions.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

    const totalMainReimbAmount = mainGridRows.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

    const totalMenopurReimbAmount = menopurGridRows.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

  //summary row for total amount
  let summaryRow = {}; 
let summaryRowMainGrid = {};
   let summaryRowMenopurGrid = {};  
    
  console.log("Task Detail::::::::", sourceData);

  if (!sourceData) {
    return (
      <div>
        <MenuBar />
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
          <CircularProgress sx={{ color: '#ec008c' }} />
          <span style={{ marginTop: '16px', color: '#ec008c', fontSize: '16px', fontWeight: 500 }}>
            Your request is being processed...
          </span>
        </Box>
      </div>
    );
  }

   if ((taskDetail?.ContractType?.trim() === 'Premier' 
   || contract === 'Moelis-Cigna-Premier Rx'
  ) && memberConcernFlag === true) {
    summaryRowMainGrid = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalMainReimbAmount).toFixed(2),
};

summaryRowMenopurGrid = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalMenopurReimbAmount).toFixed(2),
};
   } else {

summaryRow = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalReimbursement).toFixed(2),
  // All other fields left blank
};
}



  const rowsWithSummary = [...gridRows, summaryRow];
  const mainGridRowsWithSummary = [...mainGridRows, summaryRowMainGrid];
  const menopurGridRowsWithSummary = [...menopurGridRows, summaryRowMenopurGrid];


  //  if ( taskDetail.ContractType?.trim() === 'Premier' || taskDetail?.ContractType?.trim() === 'Premier') {
  //     const totalMemberPays = taskDetail.Prescriptions.reduce((sum, row) =>
  //  sum + (parseFloat(row?.['Member Pays'] || 0)), 0).toFixed(2);
  //     setTotalMemberPays(totalMemberPays);
  //     const totalWinPays = totalAmount - totalMemberPays;
  //     setTotalWinPays(totalWinPays.toFixed(2));
  //   }

  return (
    <>
    <div>
      <Toaster position="top-right" />
      
        <MenuBar />
        <div className='top-page-option'>
          <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
            <a href="#/submitted-claims" style={{ textDecoration: 'none', color: '#ec088c', display: 'inline-flex', alignItems: 'center' }}
            onClick={async () => {
                          try {
                            const user = JSON.parse(localStorage.getItem('user'));
                            const userId = user?.userId;
                            const pharmacyId = user?.pharmacyId;
                            if (!userId || !pharmacyId || !taskId || !contract) {
                              toast.error('Missing required data for unlocking.');
                              return;
                            }
                            const result = await unlockRXDetails(contract, userId, taskId, pharmacyId);
            
                            if (result.success) {
                              toast.success('Task unlocked successfully');
                            } else {
                              toast.error(result?.Message || 'Failed to unlock task');
                            }
                          } catch (err) {
                            console.error('Unlock error:', err);
                            toast.error('An error occurred while unlocking');
                          }
                        }}>
              <ChevronLeft color='#ec088c' size={18} />
              <span style={{ marginLeft: '5px' }}>Back</span>
            </a>
          </div>
         
          <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <span>Dispensed Orders</span>
                                <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }} />
                                <span>Submitted Claims</span>
                                <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }}/>
                                <span>Claims Info</span>
                              </div>
        </div>
        <div className="outer-box" style={{
          background: '#fff',
          padding: '0px',
          borderRadius: '10px',
          marginLeft: '100px',
          marginRight: '100px',
          textAlign: 'left', // force left alignment for all children
          alignItems: 'flex-start', // ensure children align left
          display: 'block' // remove any flex centering
        }}> 

        {/* Member Info */}
        <div className="open-order-box" style={{fontFamily: 'segoe ui', textAlign: 'left', alignItems: 'flex-start', display: 'block' }}>

        <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', marginBottom: '-5px',marginLeft:'25px', fontSize: '18px' }}>Member Info</div>
<br style={{ display: 'none' }} />
<div className="details-grid" style={{
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '18px 32px',
  borderRadius: '10px',
  padding: '18px 24px',
  marginBottom: '-30px',
  alignItems: 'start',
  fontSize: '14px',
  color: '#222',
  fontFamily: 'segoe ui',
  textAlign: 'left',
  justifyItems: 'start',
  width: 'fit-content',
  marginLeft: 0
}}>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '140px', display: 'inline-block', flexShrink: 0 }}>Member ID:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.MemberID}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Name:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.MemberName}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>DOB:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.DOB ? new Date(taskDetail.DOB).toLocaleDateString() : ''}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>RelationShip:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.RelationShip || 'N/A'}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Phone:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.CellPhone}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Email ID:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.EmailID}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>Certified For:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.CertifiedFor}</span>
  </div>
  
</div><br/>





<div style={{ margin: '20px 0', width: '100%', paddingLeft: '20px' }}>
  <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '15px', tableLayout: 'fixed', fontFamily: 'segoe ui' }}>
    <colgroup>
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Provider Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Authorization Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Attachments</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Name:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.SerProName}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Phone:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.Telephone}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Fax:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.Fax}</span>
          </div>
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>WIN Auth #:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.AuthNo}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Auth Duration:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail?.['Auth Duration']}</span>
          </div>
          {/* <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Contract:</strong>
            <span style={{ fontSize: '13px', marginLeft: '8px' }}>{taskDetail.Contract}</span>
          </div> */}
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          {documentArray.map((doc, index) => {
      const fileUrl = doc.documentList.replaceAll('\\', '/').replaceAll('\\\\', '/');
      const fileName = fileUrl.split('/').pop();
      // const downloadUrl = attachmentUrls[index]; // Not needed for handleFileDisplay
      return (
        <button
          key={doc.id}
          type="button"
          className="attachment-link"
          style={{
            color: 'blue',
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            fontFamily: 'segoe ui',
            fontSize: '14px',
            textDecoration: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
          onClick={() => handleFileDisplay(doc.documentList, doc.bytes)} // Pass both path and bytes
        >
          <strong style={{ fontSize: '15px', fontFamily: 'segoe ui', marginRight: '4px', textDecoration: 'none' }}>{`Prescription ${index + 1}:`}</strong>
          <span style={{ fontSize: '14px', fontFamily: 'segoe ui', textDecoration: 'underline' }}>{fileName}</span>
        </button>
      );
    })}
        </td>
      </tr>
    </tbody>
  </table>
  {/* New 2-column table below the existing table, same design */}
  {/* New 2-column table below the existing table, same design */}

 <table style={{ marginTop:'30px',borderCollapse: 'collapse', width: '100%', fontSize: '13px', tableLayout: 'fixed', fontFamily: 'segoe ui',padding: '0 5px' }}>
    <colgroup>
      <col style={{ width: '33.3%' }} />
      <col style={{ width: '66.7%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '5px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Task Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Task Notes</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ fontFamily: 'segoe ui' , padding: '6px', }}>
          
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Assigned by:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.AssignedBy}</span>
          </div>
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Group ID:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.GroupID}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Priority:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.PriorityStatus}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Received:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.ReceivedDate}</span>
          </div>
		   <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Med Start Date:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.SchStartDate}</span>
          </div>
         </td>
      <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "40px",
        maxWidth: "80%",
      }}
    >
      <div
        className="notes-box"
        style={{
          flex: "1 1 300px",
          position: 'relative',
          boxShadow: notesBoxActive ?  '#ec008c' : undefined,
          borderRadius: '6px',
          padding: '4px',
          transition: 'box-shadow 0.2s',
        }}
        onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
        tabIndex={0}
      >
        <textarea
          className="notes-textarea"
          readOnly
          value={taskDetail?.Notes || ""}
          style={{
            width: "95%",
            minHeight: "100px",
            padding: "12px",
            fontSize: "13px",
            borderRadius: "25px",
            border: "1px solid rgba(236, 152, 202)",
            resize: "vertical",
            background: 'white',
            outline: 'none',
            color: notesBoxActive ? '#ec008c' : 'black',
            transition: 'color 0.2s',
          }}
          onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
        />
      </div>
    </div>
        </td>
      </tr>
    </tbody>
  </table>

 {/* <div
  style={{
    marginTop: '30px',
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: '13px',
    tableLayout: 'fixed',
    fontFamily: 'segoe ui',
    padding: '0 5px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // center children horizontally
  }}
>
  <h2 style={{ color: '#ec008c', textAlign: 'center', marginBottom: '12px', fontWeight: 'bold', fontSize: '18px' }}>
    Task Notes
  </h2>
  <textarea
    className="notes-textarea"
    readOnly
    value={notes || ""}
    style={{
      width: "60%",
      minHeight: "100px",
      padding: "12px",
      fontSize: "13px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      resize: "vertical",
      background: 'white',
      outline: 'none',
      color: notesBoxActive ? '#ec008c' : 'black',
      transition: 'color 0.2s',
    }}
    onFocus={(e) => {
      e.target.style.border = '1px solid #ec008c';
      e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
    }}
    onBlur={(e) => {
      e.target.style.border = '1px solid #ccc';
      e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
    }}
  />
</div> */}

</div>
</div>
          
        

        {/* Shipping Info */}
        <div className="open-order-box" style={{ fontFamily: 'segoe ui' }}>
                      <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', fontSize: '18px' }}>Shipping Info</div><br/>
                      <table className='Shpping-Info-table' style={{ margin: '0 auto', width: '60%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
  <colgroup>
    <col style={{ width: '50%' }} />
    <col style={{ width: '50%' }} />
  </colgroup>
  <tbody>
    <tr>
      <td style={{ fontSize: '15px', textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Phone :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{shipping?.Phone}</span>
        </div>  
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Shipping Carrier :</strong>
          <input
            style={{
              width: '30%',
              height: '20px',
              marginLeft: '8px',
              padding: '8px',
              fontSize: '14px',
              borderRadius: '15px',
              border: '1px solid rgba(236, 152, 202)',
              color: '#222',
              fontFamily: 'Segoe UI, Arial, sans-serif',
              outline: 'none',
              boxShadow: '0 1px 4px 0 rgba(236,0,140,0.07)'
              
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}value={shippingCarrier}
      readOnly
      />
            
           
         
        </div>
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Fax :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{shipping.Fax || '—'}</span>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>#Tracking :</strong>
          <input
            type="text"
            name="trackingID"
            value={trackingNumber}
            readOnly
            style={{
              width: '30%',
              height: '20px',
              minHeight: '20px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '15px',
              border: '1px solid rgba(236, 152, 202)',
              marginLeft: '8px',
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          />
        </div>
        {/* Show tracking result below input */}
        {/* {trackingResult && (
          <div style={{ color: trackingResult.success ? 'green' : 'red', marginTop: '6px', marginLeft: '180px' }}>
            {trackingResult.success ? 'Tracking found!' : trackingResult.message}
          </div>
        )} */}
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Address :</strong>
          <textarea value={shipping?.Address || ''}
            readOnly
            style={{
              width: '80%',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '20px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
            outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          ></textarea>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Notes :</strong>
          <textarea name="trackingID"
            style={{
              width: '500px',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '20px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
           outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }} placeholder='Please enter the Notes'></textarea>
        </div>
      </td>
    </tr>
  </tbody>
</table>

</div>
        {/* <div className="open-order-box" style={{ margin: '20px 100px' }}>
          <div className="sub-section-header" style={{ color: '#ec008c', fontWeight: 'bold' }}>Shipping Info</div>
          <div className="details-grid">
            <div><strong>Address:</strong> {shipping.Address}</div>
            <div><strong>Phone:</strong> {shipping.Phone}</div>
            <div><strong>Carrier:</strong> {shippingCarrier}</div>
            <div><strong>Tracking #:</strong> {trackingNumber}</div>
          </div>
        </div> */}

        {/* Prescription Grid */}
        <div style={{ width: '100%', margin: '0 auto' }}>
          <div className="sub-section-header" style={{ color: '#ec008c', fontWeight: 'bold', fontSize: '18px' }}>Prescriptions</div>
          <div style={{ height: 'auto' }}>
            {(contractType === 'Premier' ||
              contract === 'Moelis-Cigna-Premier Rx'
            ) && memberConcernFlag === true && (
                             <>
                               {(mainGridRows.length > 0) &&<DataGrid
                                 rows={mainGridRowsWithSummary }
                                 columns={columns}
                                 pageSize={5}
                                 rowsPerPageOptions={[5]}
                                 hideFooter
                                 getRowClassName={(params) =>
                                   params.row.isSummary ? 'summary-row' : ''
                                 }
                                 sx={{
                                       fontSize: '12px',
                                       fontFamily: 'Segoe UI',
                                       '& .pink-header': {
                                         color: '#fff',
                                         backgroundColor: '#ec008c',
                                         fontWeight: 'bold',
                                          whiteSpace: 'normal !important',
                             wordBreak: 'breakWord !important',
                             overflowWrap: 'breakWord !important',
                             lineHeight: '1.3 !important',
                             textAlign: 'center', /* Optional: center the header text */
                             padding: '8px 2px !important',
                                       },
                                        '& .MuiDataGrid-row:hover': {
                                         backgroundColor: '#f5f5f5 !important',
                                         cursor: 'pointer',
                                       },// Remove blue outline on cell focus
                               '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                 outline: 'none !important',
                                 boxShadow: 'none !important',
                                 backgroundColor: 'none !important',  
                                },
                                //'& .MuiDataGrid-row:focus-within': {
                               //   backgroundColor: '#f5bcbc !important',
                               // },
                               // Remove blue outline on column header focus
                               '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                 outline: 'none !important',
                                 boxShadow: 'none !important',
                               },
                                     }}
                               />}
                               <DataGrid
                                 rows={menopurGridRowsWithSummary }
                                 columns={columnsMenopur}
                                 pageSize={5}
                                 rowsPerPageOptions={[5]}
                                 hideFooter
                                 getRowClassName={(params) =>
                                   params.row.isSummary ? 'summary-row' : ''
                                 }
                                 sx={{
                                       fontSize: '12px',
                                       fontFamily: 'Segoe UI',
                                       '& .pink-header': {
                                         color: '#fff',
                                         backgroundColor: '#ec008c',
                                         fontWeight: 'bold',
                                          whiteSpace: 'normal !important',
                             wordBreak: 'breakWord !important',
                             overflowWrap: 'breakWord !important',
                             lineHeight: '1.3 !important',
                             textAlign: 'center', /* Optional: center the header text */
                             padding: '8px 2px !important',
                                       },
                                        '& .MuiDataGrid-row:hover': {
                                         backgroundColor: '#f5f5f5 !important',
                                         cursor: 'pointer',
                                       },// Remove blue outline on cell focus
                               '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                 outline: 'none !important',
                                 boxShadow: 'none !important',
                                 backgroundColor: 'none !important',  
                                },
                                //'& .MuiDataGrid-row:focus-within': {
                               //   backgroundColor: '#f5bcbc !important',
                               // },
                               // Remove blue outline on column header focus
                               '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                 outline: 'none !important',
                                 boxShadow: 'none !important',
                               },
                                     }}
                               />
                             </>
                           )}
                                                 { (memberConcernFlag === false &&(<DataGrid
                                                   rows={rowsWithSummary}
                                                   columns={columns}
                                                   pageSize={5}
                                                   rowsPerPageOptions={[5]}
                                                   hideFooter
                                                   getRowClassName={(params) =>
                                                   params.row.isSummary ? 'summary-row' : ''}
                                                   sx={{
                                       fontSize: '12px',
                                       fontFamily: 'Segoe UI',
                                       '& .pink-header': {
                                         color: '#fff',
                                         backgroundColor: '#ec008c',
                                         fontWeight: 'bold',
                                          whiteSpace: 'normal !important',
                             wordBreak: 'breakWord !important',
                             overflowWrap: 'breakWord !important',
                             lineHeight: '1.3 !important',
                             textAlign: 'center', /* Optional: center the header text */
                             padding: '8px 2px !important',
                                       },
                                        '& .MuiDataGrid-row:hover': {
                                         backgroundColor: '#f5f5f5 !important',
                                         cursor: 'pointer',
                                       },// Remove blue outline on cell focus
                               '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                 outline: 'none !important',
                                 boxShadow: 'none !important',
                                 backgroundColor: 'none !important',  
                                },
                                //'& .MuiDataGrid-row:focus-within': {
                               //   backgroundColor: '#f5bcbc !important',
                               // },
                               // Remove blue outline on column header focus
                               '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                 outline: 'none !important',
                                 boxShadow: 'none !important',
                               },
                                     }}
                                                 />))}

             {/* {contract === 'Chewy-Aetna-Premier' && (
                          <div style={{ display: 'flex', gap: '20px', margin: '20px' }}>
                            <div style={{ flex: 1, minWidth: 400,   }}>
                              <DataGrid
                                rows={chewyFertilityRows}
                                columns={chewyColumnsFertilityGrid}
                                pageSize={4}
                                hideFooter
                                sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center',
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5bcbc !important',
              cursor: 'pointer',
            },// Remove blue outline on cell focus
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     //'& .MuiDataGrid-row:focus-within': {
    //   backgroundColor: '#f5bcbc !important',
    // },
    // Remove blue outline on column header focus
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
                              />
                            </div>
                            <div style={{ flex: 1, minWidth: 400 }}>
                              <DataGrid
                                rows={chewyRows}
                                columns={chewyColumns}
                                pageSize={4}
                                hideFooter
                                sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center', 
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5bcbc !important',
              cursor: 'pointer',
            },// Remove blue outline on cell focus
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     //'& .MuiDataGrid-row:focus-within': {
    //   backgroundColor: '#f5bcbc !important',
    // },
    // Remove blue outline on column header focus
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
                              />
                            </div>
                          </div>
                        )} */}

          </div>

        {(contract === 'HMO Illinois' 
        || contract === 'WINFertilityRx' || 
            contract === 'WINFertility Genetics' || contract === 'WINFertility DTC' )&& (
          <div style={{ textAlign: 'right', fontWeight: 'bold', marginTop: '10px', marginBottom: '20px' }}>
            Total Amount: ${parseFloat(totalWinPays).toFixed(2)}
          </div>)}
          {((taskDetail?.ContractType?.trim() === 'Premier' || taskDetail.ContractType?.trim() === 'Premier')
          || contract === 'Moelis-Cigna-Premier Rx') && (
             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '20px', color: '#000' }}>
               <div style={{ marginBottom: '4px' }}>
              Member Cost Share: ${parseFloat(totalCostShare).toFixed(2)}
            </div>
            <div>
              WIN To Pharmacy: ${parseFloat(Math.max(0, totalWinPays)).toFixed(2)}
            </div>
            {memberConcernFlag === true && (
              <div>
              WINCard Value: ${parseFloat(winCardAmount).toFixed(2)}
            </div>
              )}
              </div>)}
            
            
             {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '20px', color: '#000' }}>
  <div style={{ marginBottom: '4px' }}>
    Member Cost Share: ${parseFloat(costShareValue).toFixed(2)}
  </div>
  <div>
    WIN To Pharmacy: ${parseFloat(totalWinPays).toFixed(2)}
  </div>
  {memberConcernFlag === true && (
    <div>
    WINCard Value: ${parseFloat(winCardAmount).toFixed(2)}
  </div>
  )}
</div> */}
          {/* )} */}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
            {(contract !== 'WINFertility DTC' &&
              contract !== 'WINFertilityRx' &&
              contract !== 'WINFertility Genetics' &&
              <button className="button-open-order" onClick={handleRollback}>RollBack</button>)}
            <button className="button-open-order" onClick={ confirmBack }>Back</button>
          </div>
        </div>
      </div>

        <NeedsTrackingModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={handleModalConfirm}
          confirmMessage={modalMessage}
        />
      </div>
    </>
  );
};

export default SubmittedClaimsOpenOrder;
